/**
 * Authentication Reducer
 * 
 * Manages JWT-based authentication state
 * Tokens are stored via tokenManager, not in Redux
 */

import * as actionTypes from "../actions/actionTypes";
import { updateObject } from "../utility";

const initialState = {
  user: null, // JWT user data (replaces profile)
  loadingLogin: false,
  loadingCheck: true,
  isAuthenticated: false,
  errorMessage: null,
  loadingResetPass: false,
  screen: "LOGIN"
};

const authLoginStart = (state, action) => {
  return updateObject(state, { loadingLogin: true });
};

const authLoginFail = (state, action) => {
  return updateObject(state, {
    loadingLogin: false,
    errorMessage: action.message
  });
};

const authLoginSuccess = (state, action) => {
  return updateObject(state, {
    loadingLogin: false,
    user: action.profileData, // Store JWT user data
    isAuthenticated: true
  });
};

const authCheckStart = (state, action) => {
  return updateObject(state, { loadingCheck: true });
};

const authCheckFail = (state, action) => {
  return updateObject(state, { loadingCheck: false });
};

const authCheckSuccess = (state, action) => {
  return updateObject(state, {
    loadingCheck: false,
    isAuthenticated: true
  });
};

const authLogout = (state, action) => {
  return updateObject(state, {
    user: null, // Clear user data
    isAuthenticated: false
  });
};

const authResetPasswordStart = (state, action) => {
  return updateObject(state, {
    loadingResetPass: true
  });
};

const authResetPasswordSuccess = (state, action) => {
  return updateObject(state, {
    loadingResetPass: false,
    screen: "CODE"
  });
};

const authResetPasswordFail = (state, action) => {
  return updateObject(state, {
    loadingResetPass: false
  });
};

const authScreenChange = (state, action) => {
  return updateObject(state, {
    screen: action.value
  });
};

const authNewPassStart = (state, action) => {
  return updateObject(state, {
    loadingResetPass: true
    // screen: "LOGIN" //privremeno
  });
};

const authNewPassSuccess = (state, action) => {
  return updateObject(state, {
    loadingResetPass: false,
    screen: "LOGIN"
  });
};

const authNewPassFail = (state, action) => {
  return updateObject(state, {
    loadingResetPass: false
  });
};

const reducer = (state = initialState, action) => {
  switch (action.type) {
    case actionTypes.AUTH_LOGIN_START:
      return authLoginStart(state, action);
    case actionTypes.AUTH_LOGIN_FAIL:
      return authLoginFail(state, action);
    case actionTypes.AUTH_LOGIN_SUCCESS:
      return authLoginSuccess(state, action);
    case actionTypes.AUTH_CHECK_START:
      return authCheckStart(state, action);
    case actionTypes.AUTH_CHECK_FAIL:
      return authCheckFail(state, action);
    case actionTypes.AUTH_CHECK_SUCCESS:
      return authCheckSuccess(state, action);
    case actionTypes.AUTH_LOGOUT:
      return authLogout(state, action);
    case actionTypes.AUTH_RESET_PASSWORD_START:
      return authResetPasswordStart(state, action);
    case actionTypes.AUTH_RESET_PASSWORD_SUCCESS:
      return authResetPasswordSuccess(state, action);
    case actionTypes.AUTH_RESET_PASSWORD_FAIL:
      return authResetPasswordFail(state, action);
    case actionTypes.AUTH_SCREEN_CHANGE:
      return authScreenChange(state, action);
    case actionTypes.AUTH_SEND_NEW_PASS_START:
      return authNewPassStart(state, action);
    case actionTypes.AUTH_SEND_NEW_PASS_SUCCESS:
      return authNewPassSuccess(state, action);
    case actionTypes.AUTH_SEND_NEW_PASS_FAIL:
      return authNewPassFail(state, action);
    default:
      return state;
  }
};

export default reducer;
